export default __webpack_public_path__ + "static/media/solution_45.ab90ef97.svg";